"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsxs)("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [(0, jsx_runtime_1.jsx)("path", {
      d: "M20.5 39.5C18.1816 39.5 15.9328 37.5038 14.2341 33.9276C12.5533 30.3891 11.5 25.4655 11.5 20C11.5 14.5345 12.5533 9.61092 14.2341 6.07239C15.9328 2.49617 18.1816 0.499999 20.5 0.5C22.8184 0.5 25.0672 2.49617 26.7659 6.07239C28.4467 9.61092 29.5 14.5345 29.5 20C29.5 25.4655 28.4467 30.3891 26.7659 33.9276C25.0672 37.5038 22.8184 39.5 20.5 39.5Z",
      stroke: "currentColor"
    }), (0, jsx_runtime_1.jsx)("path", {
      opacity: "0.2",
      d: "M39.5 19.5C39.5 21.8184 37.5038 24.0672 33.9276 25.7659C30.3891 27.4467 25.4655 28.5 20 28.5C14.5345 28.5 9.61092 27.4467 6.07239 25.7659C2.49617 24.0672 0.5 21.8184 0.5 19.5C0.5 17.1816 2.49617 14.9328 6.07239 13.2341C9.61092 11.5533 14.5345 10.5 20 10.5C25.4655 10.5 30.3891 11.5533 33.9276 13.2341C37.5038 14.9328 39.5 17.1816 39.5 19.5Z",
      stroke: "currentColor"
    })]
  });
};

exports.default = Icon;